import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Zap, Shield, Award, Wrench } from "lucide-react";
// import solarFieldImage from "@/assets/solar-field.jpg";

const SolarPanels = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const panels = [
    {
      name: "Residential Solar Panels",
      power: "400W - 500W",
      efficiency: "22.5%",
      warranty: "25 Years",
      price: "From $299/panel",
      features: ["High Efficiency", "Weather Resistant", "Easy Installation", "Smart Monitoring"]
    },
    {
      name: "Commercial Solar Systems",
      power: "500W - 600W",
      efficiency: "23.1%",
      warranty: "25 Years", 
      price: "Custom Quote",
      features: ["Enterprise Grade", "High Durability", "Scalable Design", "Remote Monitoring"]
    },
    {
      name: "Industrial Solar Arrays",
      power: "600W+",
      efficiency: "24.2%",
      warranty: "30 Years",
      price: "Contact Us",
      features: ["Maximum Power", "Extreme Durability", "Grid Integration", "24/7 Support"]
    }
  ];

  return (
    <section id="solar-panels" className="py-20 bg-gradient-to-b from-background to-solar-light-blue">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 border-primary text-primary">
            Our Products
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-solar bg-clip-text text-transparent">
            Premium Solar Panel Solutions
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Discover our range of high-efficiency solar panels designed for residential, commercial, and industrial applications.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {panels.map((panel, index) => (
            <Card key={index} className="border-0 shadow-card-solar hover:shadow-solar transition-all duration-300 hover:-translate-y-1">
              <CardHeader>
                <CardTitle className="text-xl font-bold text-primary">{panel.name}</CardTitle>
                <CardDescription className="text-lg font-semibold text-accent">
                  {panel.price}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <Zap className="h-4 w-4 text-solar-yellow inline mr-2" />
                    <span className="font-medium">Power: {panel.power}</span>
                  </div>
                  <div>
                    <Award className="h-4 w-4 text-solar-green inline mr-2" />
                    <span className="font-medium">Efficiency: {panel.efficiency}</span>
                  </div>
                  <div className="col-span-2">
                    <Shield className="h-4 w-4 text-primary inline mr-2" />
                    <span className="font-medium">Warranty: {panel.warranty}</span>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <h4 className="font-semibold text-foreground">Key Features:</h4>
                  <ul className="space-y-1">
                    {panel.features.map((feature, idx) => (
                      <li key={idx} className="text-sm text-muted-foreground flex items-center">
                        <div className="w-1.5 h-1.5 bg-primary rounded-full mr-2"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <Button 
                  variant="solar" 
                  className="w-full"
                  onClick={scrollToContact}
                >
                  <Wrench className="mr-2 h-4 w-4" />
                  Get Installation Quote
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="relative rounded-2xl overflow-hidden">
          <div 
            className="h-64 bg-cover bg-center"
            style={{ backgroundImage: `` }}
          >
            <div className="absolute inset-0 bg-primary/80 flex items-center justify-center">
              <div className="text-center text-primary-foreground">
                <h3 className="text-3xl font-bold mb-4">
                  Why Choose Our Solar Panels?
                </h3>
                <p className="text-lg mb-6 max-w-2xl">
                  Industry-leading efficiency, extended warranties, and professional installation backed by years of experience.
                </p>
                <Button variant="energy" size="lg" onClick={scrollToContact}>
                  Schedule Consultation
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolarPanels;